module.exports = __webpack_public_path__ + "static/img/96_phase_function_Paper_PointsHejduk_Prediction.e6acd14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 4Df9
// module chunks = 0